import { jsx as _jsx } from "react/jsx-runtime";
export const matches = (text, pattern) => {
    if (!pattern)
        return text;
    let next = 0;
    const elements = [];
    pattern.lastIndex = 0;
    for (const match of text.matchAll(pattern)) {
        if (next < match.index) {
            elements.push(text.slice(next, match.index));
        }
        elements.push(_jsx("em", { children: match[0] }, match.index));
        next = match.index + match[0].length;
    }
    elements.push(text.slice(next));
    return elements;
};
